import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Hexagon, Lock, AlertCircle } from 'lucide-react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { Input } from '../components/ui/input';

export default function AdminLoginPage() {
  const { API } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await axios.post(`${API}/ayo/login`, { email, password });
      localStorage.setItem('hp_admin_token', res.data.token);
      localStorage.setItem('hp_admin_user', JSON.stringify(res.data.user));
      navigate('/ayo-panel');
    } catch (err) {
      setError(err.response?.data?.detail || 'Access denied');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#09090B] flex items-center justify-center p-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 mb-4">
            <div className="relative">
              <Hexagon className="w-8 h-8 text-amber-500 fill-amber-500/20" />
              <Lock className="w-3.5 h-3.5 text-amber-500 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
            </div>
          </div>
          <h1 className="font-heading font-black text-xl text-white mb-1">Admin Access</h1>
          <p className="text-xs text-zinc-600">Authorized personnel only</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-3" data-testid="admin-login-form">
          <Input
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            className="bg-[#121214] border-white/10 text-white h-11"
            data-testid="admin-login-email"
          />
          <Input
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            className="bg-[#121214] border-white/10 text-white h-11"
            data-testid="admin-login-password"
          />
          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 rounded-lg bg-amber-500 text-black font-bold text-sm disabled:opacity-50 hover:bg-amber-400 transition-colors"
            data-testid="admin-login-submit"
          >
            {loading ? 'Authenticating...' : 'Sign In'}
          </button>
        </form>

        {error && (
          <div className="mt-4 flex items-center gap-2 px-4 py-3 rounded-lg bg-red-500/10 border border-red-500/20" data-testid="admin-login-error">
            <AlertCircle className="w-4 h-4 text-red-400 flex-shrink-0" />
            <p className="text-xs text-red-400">{error}</p>
          </div>
        )}
      </div>
    </div>
  );
}
